import getters from './getters';
import actions from './actions';

function initState() {
    return {
        listingSortOptions: [],
        page: 1,
        pageSize: 24,
        sort: null,
        quickSearchState: 0,
        drawing: false,
        loading: true,
        isMapLoading: false,
        searchParams: {},
        mapResult: {},
        selectedHouse: {},
        lastSelectedHouse: null,
        gridOrListType: '',
        showInsight: false,
        lastLayout: '',
        mapInited: false,
        marketReport: {},
        averageData: {
            count: 0,
            avgResultList: []
        },
        centerPoint: '',
        zoom: 12,
        property_gathering_amount: 10,
        breadCrumbs: []
    };
}
export default {
    state: initState,
    getters,
    actions
};
